__turbopack_context__.v({
  "BasketRedirectAlert": "basket-redirect-alert-module-scss-module__xPdPmG__BasketRedirectAlert",
  "BasketRedirectAlert__Description": "basket-redirect-alert-module-scss-module__xPdPmG__BasketRedirectAlert__Description",
});
